export default __webpack_public_path__ + "static/media/worldcup.82ee1908.png";